import { supabase } from '../supabase';

// Histórico de acessos: avisa o servidor que a pessoa abriu uma tela, entrou ou saiu (api/acessos).
// O e-mail vem do login no servidor — aqui só vai o que foi aberto. Falha de rede não atrapalha o uso.
export async function registrarAcesso({ tipo = 'tela', caminho, tela, detalhe }) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) return;
    await fetch('/api/acessos?acao=registrar', {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
      body: JSON.stringify({ tipo, caminho, tela, detalhe }),
    });
  } catch { /* sem rede: segue */ }
}
